import React from 'react';

const FACTOR_LABELS = {
  totp: 'Authenticator app',
  backup_codes: 'Backup codes',
  sms: 'SMS',
  email_otp: 'Email OTP',
  webauthn: 'Security key / Passkey',
};

function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric', month: 'short', day: 'numeric',
    });
  } catch {
    return iso;
  }
}

export default function FactorList({ factors, onRequestDisable }) {
  if (!factors || factors.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">
        No two-factor methods are active for your account.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {factors.map((f) => (
        <li
          key={f.factor_id}
          className="flex items-center justify-between bg-white border border-gray-200 rounded-md px-4 py-3"
        >
          <div>
            <div className="text-sm font-medium text-gray-900">
              {FACTOR_LABELS[f.factor_type] || f.factor_type}
              {f.factor_type === 'backup_codes' && f.metadata?.remaining !== undefined && (
                <span className="ml-2 text-xs text-gray-500">
                  ({f.metadata.remaining} of {f.metadata.total} remaining)
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500">
              Added {formatDate(f.activated_at || f.created_at)}
              {f.last_used_at && ` · Last used ${formatDate(f.last_used_at)}`}
            </div>
          </div>
          <button
            type="button"
            onClick={() => onRequestDisable(f)}
            className="text-sm text-red-600 hover:text-red-700 hover:underline"
          >
            Disable
          </button>
        </li>
      ))}
    </ul>
  );
}
